import { Component, OnInit, HostListener } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { DecodeTicketService } from '../../shared/services/decode-ticket.service';
import { KeyboardServiceService } from '../../shared/keyboard-service/keyboard-service.service';
import { ValidationService } from '../../shared/services/validation.service';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {
  showSpinner: boolean = false;
  passwordInvalid: boolean = false;
  errorMessage: string = '';
  signup = {
    password: ''
  }

  constructor (
    private keyboardSvc: KeyboardServiceService,
    private dataSvc: DatabusService,
    private decoder: DecodeTicketService,
    private idle: Idle,
    private validate: ValidationService,
    private router: Router ) { 
      this.keyboardSvc.currentModel = 'password';
    }

  SetModelFromKeyboard (val) {
    let currentModel = this.keyboardSvc.getCurrentModel();

    if(val === 'DELETE') {
      this.signup[currentModel] = this.keyboardSvc.deleteValue(this.signup[currentModel]);
    } else {
      this.signup[currentModel] = this.signup[currentModel] + val;
    }
  }

  isCurrent (name) {
    return this.keyboardSvc.currentModel === name;
  }

  Cancel () {
    this.router.navigate(['/scanticket']);
  }

  EnterPassword () {
    this.showSpinner = true;
    if(this.signup.password && this.signup.password !== '') {
      this.CheckAccount()
    } else {
      this.showSpinner = false;
    }
  }

  CheckAccount() {
    let login = {
      email: this.dataSvc.currentEmail,
      password: this.signup.password
    }
    this.validate.accountLogin(login)
    .then((results) => {
      var status = parseInt(results.status);
      if(status >= 400) {
        this.showSpinner = false;
        this.errorMessage = results.message;
        this.passwordInvalid = true;
      } else {
        if(results.region !== '' && results.city !== '' && results.region !== '') {
          //route to already have extended profile
          this.router.navigate(['/completeexit']);
        } else {
          this.dataSvc.currentLogin = results;
          this.dataSvc.password = this.signup.password;
          this.router.navigate(['/completeprofile']);
        }        
      }      
    })
    .catch((err) => {
      this.showSpinner = false;
      this.errorMessage = "There was a problem submitting password.";
      this.passwordInvalid = true;
      console.log(err)
    });   
  }

  ngOnInit() {
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/password/password.component.ts